import React, { Component } from "react";
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setLoader } from "../../../actions/action-creators";
import moment from "moment";
import CONSTANTS from "../../../constants";
import { Drawer } from "@material-ui/core";
import TicketDetail from "../../global/support/ticket";
import { groupArrayOnKey } from "../../../actions";

const fmtDT = (v) => moment(v).utcOffset("+05:30").format("Do MMM'YY, hh:mm A");

const TICKET_STATUS_STYLES = {
    0: { bg: "#e6f7ee", color: "#1a7a42" },
    1: { bg: "#f0f0f0", color: "#666"    },
    2: { bg: "#fff7e6", color: "#d46b08" },
};

const ticketStatusBadge = (status) => {
    const label = CONSTANTS.TICKET_STATUS_TEXT[status] || "Unknown";
    const cfg = TICKET_STATUS_STYLES[status] || { bg: "#f0f0f0", color: "#666" };
    return (
        <span style={{ background: cfg.bg, color: cfg.color, borderRadius: 999, padding: "3px 10px", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>
            {label}
        </span>
    );
};

class UserTickets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tickets: [],
            isShowTicket: false,
        };
    }

    componentDidMount() {
        this.fetchTickets();
    }

    fetchTickets = async () => {
        store.dispatch(setLoader(true));
        try {
            let body = { user_id: this.props.user_id, includeAll: true, archive_status: [0, 1] };
            let apiData = await ApiEndpoints.Support.fetchTickets(body);
            let tickets = apiData.data.data.sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
            let jobList = groupArrayOnKey(store.getState().jobList, "job_id", true);
            tickets = tickets.map(ticket => {
                if (ticket.tag_type === "JOB" && ticket.tag_id && jobList[ticket.tag_id])
                    ticket.jobData = jobList[ticket.tag_id];
                return ticket;
            });
            this.setState({ tickets });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    render() {
        let { tickets, isShowTicket } = this.state;
        return (
            <div>
                {tickets.length === 0 ? (
                    <div style={S.empty}>No tickets found.</div>
                ) : (
                    tickets.map((ticket, i) => (
                        <div key={i} style={S.card} onClick={() => this.setState({ isShowTicket: ticket })}>
                            <div style={S.cardTop}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={S.title}>{ticket.ticket_title || "—"}</div>
                                    <div style={S.meta}>
                                        {CONSTANTS.TICKET_TYPE_TEXT[ticket.ticket_type] || ticket.ticket_title || "NA"}
                                        {ticket.jobData
                                            ? ` • ${ticket.jobData.Employer.employer_name} - ${ticket.jobData.title}`
                                            : ""}
                                    </div>
                                    <div style={S.bottomRow}>
                                        <span style={S.ticketId}>#{ticket.ticket_id}</span>
                                        {!!ticket.archive_status && (
                                            <span style={S.archivedBadge}>Archived</span>
                                        )}
                                        {!!ticket.Agent && (
                                            <span style={S.agentBadge}>{ticket.Agent.first_name}</span>
                                        )}
                                        {!!ticket.rating && (
                                            <span style={{ fontSize: 16 }}>
                                                {{"1":"😤","2":"😔","3":"😐","4":"😊","5":"😍"}[ticket.rating]}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div style={{ textAlign: "right", flexShrink: 0 }}>
                                    {ticketStatusBadge(ticket.status)}
                                    <div style={S.dateText}>{fmtDT(ticket.created_on)}</div>
                                </div>
                            </div>
                        </div>
                    ))
                )}

                <Drawer
                    anchor="right"
                    ModalProps={{ style: { zIndex: 99999999 } }}
                    PaperProps={{ style: { width: "50%", overflow: "hidden" } }}
                    open={!!isShowTicket}
                    onClose={() => this.setState({ isShowTicket: false })}
                >
                    <div style={{ padding: 16, height: "100%" }}>
                        {!!isShowTicket && (
                            <TicketDetail
                                ticketData={isShowTicket}
                                markTicketResolved={() => {}}
                                updateTicketData={() => {}}
                                addRemoveUpdateTicket={() => {}}
                                prevTicket={false}
                                nextTicket={false}
                            />
                        )}
                    </div>
                </Drawer>
            </div>
        );
    }
}

const S = {
    card:          { border: "1px solid #e8e8e8", borderRadius: 12, padding: "14px 18px", marginBottom: 10, background: "#fff", cursor: "pointer" },
    cardTop:       { display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 },
    title:         { fontWeight: 700, fontSize: 14, color: "#1a1a1a", marginBottom: 4 },
    meta:          { fontSize: 12, color: "#666", marginBottom: 6 },
    bottomRow:     { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
    ticketId:      { fontSize: 12, color: "#2980b9", fontWeight: 600 },
    archivedBadge: { background: "#fff7e6", color: "#d46b08", borderRadius: 999, padding: "2px 8px", fontSize: 10, fontWeight: 700 },
    agentBadge:    { background: "#f5f5f5", color: "#555", borderRadius: 999, padding: "2px 8px", fontSize: 10, fontWeight: 600 },
    dateText:      { fontSize: 11, color: "#aaa", marginTop: 5 },
    empty:         { padding: "40px 20px", textAlign: "center", color: "#aaa", fontSize: 14 },
};

export default UserTickets;
